import React, { useState } from 'react'
import { Box, Flex, Text, Icon } from '@chakra-ui/react'
import { ChevronDown } from 'lucide-react'

interface CollapsibleSectionProps {
  title: string
  badge?: string
  defaultOpen?: boolean
  isOpen?: boolean
  onToggle?: () => void
  children: React.ReactNode
  id?: string
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  badge,
  defaultOpen = false,
  isOpen: controlledOpen,
  onToggle,
  children,
  id,
}) => {
  const [internalOpen, setInternalOpen] = useState(defaultOpen)
  const isOpen = controlledOpen !== undefined ? controlledOpen : internalOpen

  const handleToggle = () => {
    if (onToggle) {
      onToggle()
    } else {
      setInternalOpen((prev) => !prev)
    }
  }

  return (
    <Box id={id}>
      <Flex
        align="center"
        justify="space-between"
        px="4px"
        py="10px"
        cursor="pointer"
        onClick={handleToggle}
        borderBottom="1px solid"
        borderColor="solid.100"
        _hover={{ bg: 'solid.25' }}
        borderRadius="4px"
        transition="background 0.15s"
      >
        <Flex align="center" gap="10px">
          <Text fontSize="14px" fontWeight="700" color="solid.900">
            {title}
          </Text>
          {badge && (
            <Flex
              align="center"
              justify="center"
              bg="primary.0"
              color="primary.100"
              borderRadius="10px"
              px="8px"
              h="20px"
              fontSize="11px"
              fontWeight="600"
            >
              {badge}
            </Flex>
          )}
        </Flex>
        <Icon
          as={ChevronDown}
          boxSize="18px"
          color="solid.400"
          transform={isOpen ? 'rotate(180deg)' : 'rotate(0deg)'}
          transition="transform 0.2s"
        />
      </Flex>
      <Box
        overflow="hidden"
        maxH={isOpen ? '9999px' : '0px'}
        opacity={isOpen ? 1 : 0}
        transition="max-height 0.3s ease, opacity 0.2s ease"
        pt={isOpen ? '16px' : '0'}
      >
        {children}
      </Box>
    </Box>
  )
}

export default CollapsibleSection
